import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';


// import {
// 	TableDarkIcon,
// 	TableDarkIconNew,
// 	// TableLightIcon
// } from "../Icon";

import {
	toggleBtnProfile,
} from '../../../redux/diagram/diagram.actions';

import {
	selectIsBtnProfileEnabled,
	selectIsBtnPopupNewsEnabled,
	selectIsBtnExportImageEnabled,
} from '../../../redux/diagram/diagram.selectors';

import {
	selectIsModalSupportEnabled,
	selectIsModalDiagramShareEnabled,
} from '../../../redux/main/main.selectors';
import { toggleModalDiagramShare, toggleSupport } from '../../../redux/main/main.actions';

import * as Tooltip from '@radix-ui/react-tooltip';

import './ControlsTopRight.scss';

export const ControlsTopRight = () => {
	const { diagramId } = useParams();  // отримаємо ID діаграми з URL

	const dispatch = useDispatch();

	const history = useHistory();

	const { t, i18n } = useTranslation();

	const handleClick = () => {
		setTimeout(() => {
			history.push(`/`);
		}, 100);
	};



	const isBtnPopupNewsEnabled = useSelector(selectIsBtnPopupNewsEnabled);
	const isBtnExportImageEnabled = useSelector(selectIsBtnExportImageEnabled);

	const isModalSupportEnabled = useSelector(selectIsModalSupportEnabled);
	const isModalDiagramShareEnabled = useSelector(selectIsModalDiagramShareEnabled);

	const isBtnProfileEnabled = useSelector(selectIsBtnProfileEnabled);
	const profileBtnRef = useRef(null);
	const profileMenuRef = useRef(null);


	useEffect(() => {
		const handleDocumentClick = (event) => {
			// check if press any button exept 'left mouse button' then return nothing
			if (event.button !== 0) {
				return;
			}

			// check if 'profile menu enabled' and click outside of 'profile menu' and 'profile button'
			if (
				isBtnProfileEnabled &&
				!profileMenuRef.current?.contains(event.target) &&
				!profileBtnRef.current?.contains(event.target)
			) {
				dispatch(toggleBtnProfile());
			}
		};

		document.addEventListener('click', handleDocumentClick);
		return () => {
			document.removeEventListener('click', handleDocumentClick);
		};
	}, [
		dispatch,
		isBtnProfileEnabled,
	]);


	// profile menu
	const getProfileMenu = (isBtnProfileEnabled) => {
		if (!isBtnProfileEnabled) {
			return;
		}

		if (!profileBtnRef.current) {
			return;
		}

		const rect = profileBtnRef.current.getBoundingClientRect();
		// const top = rect.bottom + window.scrollY + 1;
		const top = rect.bottom + window.scrollY + 2;
		// const right = rect.right + window.scrollX - 5;
		// const rightOffset = window.innerWidth - rect.right;
		// const rightOffset = document.documentElement.scrollWidth - (rect.right + window.scrollX) - 88;
		const rightOffset = document.documentElement.scrollWidth - (rect.right + window.scrollX) - 84;

		return (
			<div
				className={`profile-group`}
				ref={profileMenuRef}
				style={{ top: `${top}px`, right: `${rightOffset}px` }}
			>
				<div className="controls-group">
					<div className="control">
						<button
							className={`control-button control-button-profile`}
							type="button"
							title=""
							aria-label="Color"
							aria-pressed="false"
						// onClick={() => { handleClick(); }}
						>
							<div className='button-profile'>
								<span className="button-profile-text">E</span>
							</div>
							<div className='button-profile-text2'>Emily Nguyen</div>
						</button>
					</div>

					<div className="control control-view-profile">
						<button
							className={`control-button button-view-profile`}
							type="button"
							title=""
							aria-label="Color"
							aria-pressed="false"
							style={{ fontSize: '24px', fontWeight: 700 }}
							onClick={() => {
								const url = `/settings/profile`;
								dispatch(toggleBtnProfile());
								history.push(url);
							}}

						>
							View Profile
						</button>
					</div>

				</div>
			</div>
		);
	};


	return (
		// <div className="controls_top_right" style={{ top: `${isBtnPopupNewsEnabled ? 66 : 9 }px`}}>
		<div className={`controls_top_right ${isBtnExportImageEnabled ? 'hide' : ''}`} style={{ top: `${isBtnPopupNewsEnabled ? 58 : 9}px` }}>
			<div className="controls-row">

				{getProfileMenu(isBtnProfileEnabled)}

				<div className="controls-group">
					{/*
				<div className="control">
					<button
						className='control-button not-now'
						type="button"
						title="Grid"
						aria-label="Grid"
						aria-pressed="false"
						onClick={() => dispatch(enableGrid({}))}
					>
						5-Notifications
					</button>
				</div>

				*/}

					<div className="control">
						<button
							className={`control-button button-features ${isModalSupportEnabled ? 'selected' : ''}`}
							type="button"
							// title="Title"
							// aria-label="Title"
							aria-pressed="false"
							onClick={() => dispatch(toggleSupport('feature', 'canvas'))}
						>
							{/* <span className="span-logo" aria-hidden="true">Feedback</span> */}
							<span className="button-text" aria-hidden="true">
								{t('t.ctrl_top_right.feature_req')}
							</span>
						</button>
					</div>

					<div className="control-divider right"></div>

					<Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									disabled
									// className={`control-button button-comments ${isModalDiagramShareEnabled ? 'selected' : ''}`}
									className={`control-button button-comments disabled`}
									type="button"
									aria-pressed="false"
								// onClick={() => dispatch(toggleModalDiagramShare('canvas', diagramId))}
								>
									<svg className='icont-comment-top' width="25px" height="25px" viewBox="0 0 24 24">
										<g>
											<path
												d="M20,20h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h4 c0.6,0,1,0.4,1,1s-0.4,1-1,1H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v12C24,18.2,22.2,20,20,20z"></path>
										</g>
										<g>
											<path
												d="M12,24c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4 l-4,4C12.5,23.9,12.3,24,12,24z"></path>
										</g>
										<g>
											<path d="M18,7H6C5.4,7,5,6.6,5,6s0.4-1,1-1h12c0.6,0,1,0.4,1,1S18.6,7,18,7z"></path>
										</g>
										<g>
											<path d="M13,11H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h7c0.6,0,1,0.4,1,1S13.6,11,13,11z"></path>
										</g>
										<g>
											<path d="M16,15H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S16.6,15,16,15z"></path>
										</g>
									</svg>
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="bottom"
								align="center"
								sideOffset={10}
							>
								<span>Notifications (soon)</span>
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root>


					<div className="control-divider left"></div>

					{/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
						<Tooltip.Trigger asChild>
							<div className="control">
								<button
									disabled
									ref={profileBtnRef}
									className={`control-button button-profile`}
									type="button"
									aria-pressed="false"
								// onClick={() => {
								// }}
								>
									<span className="button-profile-text">E</span>
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="bottom"
								align="center"
								sideOffset={10}
							>
								<span>Profile</span>
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

					<div className="control">
						<button
							ref={profileBtnRef}
							className={`control-button button-profile ${isBtnProfileEnabled && 'selected'}`}
							type="button"
							aria-pressed="false"
							onClick={() => dispatch(toggleBtnProfile())}
						>
							<span className="button-profile-text">E</span>
						</button>
					</div>

					<div className="control-divider"></div>

					<div className="control">
						<button
							className={`control-button button-share ${isModalDiagramShareEnabled ? 'selected' : ''}`}
							type="button"
							aria-pressed="false"
							onClick={() => dispatch(toggleModalDiagramShare('canvas', diagramId))}
						>
							{/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
							stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
							<path
								d="M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"></path>
						</svg> */}
							<span className="button-text" aria-hidden="true">Share</span>
						</button>
					</div>

				</div>

			</div>
		</div>
	);
};

export default ControlsTopRight;






















